import { useState, useEffect, useContext, createContext } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const SchoolContext = createContext();

export const SchoolProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [currentSchool, setCurrentSchool] = useState(null);
  const [schoolSettings, setSchoolSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Load school data
  useEffect(() => {
    if (!currentUser) {
      setCurrentSchool(null);
      setLoading(false);
      return;
    }
    
    // Fetch school data from API
    // For now, use mock data
    setCurrentSchool({
      id: 'school-1',
      name: 'SafeLine Academy',
      address: '123 School St, City, State 12345',
      adminId: currentUser?.uid
    });
    
    setSchoolSettings({
      theme: 'default',
      notifications: true,
      autoApproveGuests: false,
      requirePhotoId: true
    });
    
    setLoading(false);
  }, [currentUser]);
  
  const updateSchool = (data) => {
    setCurrentSchool(prev => ({...prev, ...data}));
    // In a real app, would call API to update school data
    // apiService.schools.update(currentSchool.id, data);
  };
  
  const updateSettings = (data) => {
    setSchoolSettings(prev => ({...prev, ...data}));
    // In a real app, would call API to update settings
    // apiService.schools.updateSettings(currentSchool.id, data);
  };
  
  return (
    <SchoolContext.Provider value={{
      currentSchool,
      schoolSettings,
      loading,
      updateSchool,
      updateSettings
    }}>
      {children}
    </SchoolContext.Provider>
  );
};

export const useSchoolContext = () => {
  const context = useContext(SchoolContext);
  if (!context) {
    throw new Error('useSchoolContext must be used within a SchoolProvider');
  }
  return context;
};

export default useSchoolContext;
